import { DoctorSimple } from '@dreryk/egabinet-personnel-frontend-api';
import { PatientGroup } from '@dreryk/egabinet-patient-frontend-api';

import { Header, MarginPosition } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';
import { visitPaths } from '~libs.desktop.shared.paths';

import { appointmentsTranslationKeys } from '../translations';

import { AppointmentsActionBar } from './actionBar/AppointmentsActionBar';
import { GoToPatientHistoryAction } from './actionBar/GoToPatientHistoryAction';
import { AppointmentsFilterChips } from './filters/AppointmentsFilterChips/AppointmentsFilterChips';
import { AppointmentsFilterPanel } from './filters/AppointmentsFilterPanel/AppointmentsFilterPanel';
import { AppointmentsTable } from './table/AppointmentsTable';
import { AppointmentsFiltersContextProvider } from './filters/AppointmentFilter.context';
import { GoToWaitlistAction } from './actionBar/GoToWaitlistAction';

type AppointmentsPanelProps = {
   readonly doctors: DoctorSimple[];
   readonly currentDoctor: DoctorSimple | null;
   readonly patientGroups: PatientGroup[];
};

export const AppointmentsPanel = (props: AppointmentsPanelProps): JSX.Element => {
   const searchingAllDoctorsAvailable = protectFeature('searchingAllPractitioners');
   const doctorsFilterAvailable = searchingAllDoctorsAvailable && props.doctors.length > 1;
   const { patientId } = visitPaths.useAppointmentsListSearchParams();

   return (
      <AppointmentsFiltersContextProvider>
         <Header testId={'appointments'} margin={MarginPosition.NONE}>
            {appointmentsTranslationKeys.appointments}
         </Header>
         <AppointmentsFilterPanel
            currentDoctor={props.currentDoctor}
            doctors={props.doctors}
            patientGroups={props.patientGroups}
            doctorsFilterAvailable={doctorsFilterAvailable}
         />
         <AppointmentsFilterChips
            doctors={props.doctors}
            patientGroups={props.patientGroups}
            doctorsFilterAvailable={doctorsFilterAvailable}
         />
         <AppointmentsTable
            currentDoctor={props.currentDoctor}
            doctors={props.doctors}
            doctorsFilterAvailable={doctorsFilterAvailable}
         />
         {patientId ? (
            <AppointmentsActionBar>
               {patientId ? <GoToPatientHistoryAction patientId={patientId} /> : null}
            </AppointmentsActionBar>
         ) : null}
         {patientId
            ? null
            : // TODO DREGAB-27120
              protectFeature(
                 'experimental',
                 <AppointmentsActionBar>
                    <GoToWaitlistAction />
                 </AppointmentsActionBar>
              )}
      </AppointmentsFiltersContextProvider>
   );
};
